import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const contractRoleFilterLabel = () => t({ message: 'Contract role', comment: 'Insights filter: Contract role' });
export function ContractRoleFilter() {
    return (<CommonMetadataAllowedValuesFilter name="ContractRole" field="metadataDocumentContractRole" label={contractRoleFilterLabel()}/>);
}
